export default "__VITE_ASSET__Elnozako__"